import { createFrontendModule } from '@backstage/frontend-plugin-api';

export const appviaApiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [],
});
